<mat-toolbar style="min-height: 40px; max-height: 40px;">

    <!-- <span class="flex-1"></span> -->
    <span class="f-s-12 p-r-16">Oregon Health Authority</span>
    <span class="f-s-12 p-r-16">Public Health Lab</span>
    <span class="f-s-12 p-r-16">Oregon Environmental Laboratory Accreditation Program</span>
    <span class="f-s-12">{{environment.build}} Version {{environment.version}}</span>
  
</mat-toolbar>
